import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import SpinnerLogo from '../../../../../components/loader/SpinnerLogo';
import useFetch from '../../../../../hooks/useFetch';
import { ContractService } from '../../../../../services/contract/contractService';
import ContractFieldsSearch from '../../../components/ContractFieldsSearch';
import ContractProfileLayoutWrapper from '../../ContractProfileLayoutWrapper';
import ClientContractFormInfo from './ClientContractFormInfo';
import ConsultancyContractFormInfo from './ConsultancyContractFormInfo';
import ContractDataFormInfo from './ContractDataFormInfo';
import ProductContractFormInfo from './ProductContractFormInfo';
import StudentContractFormInfo from './StudentContractFormInfo';

const ContractInfo = () => {

    const { id = '' } = useParams<{ id: string }>();
    const service = new ContractService();

    const [data] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getContractById(id);
        return response.getResponseData();
    }, [id]));

    return (
        <ContractProfileLayoutWrapper>
            {data ? (
                <>
                    <ContractFieldsSearch targetId="contract-info-fields" className="mt-3" />
                    <div id="contract-info-fields" className={`mt-3 flex flex-col gap-5 w-full transition-all duration-1000 ease-in-out md:relative pe-2`} >
                        <ContractDataFormInfo data={data} />
                        <ClientContractFormInfo data={data} />
                        <StudentContractFormInfo data={data} />
                        <ProductContractFormInfo data={data} />
                        <ConsultancyContractFormInfo data={data} />
                    </div>
                </>
            ) : (
                <SpinnerLogo />
            )}
        </ContractProfileLayoutWrapper>
    );
};

export default ContractInfo;
